import React from "react";
import Logo from "../common/Logo.jsx";
import PortalTitle from "../common/PortalTitle.jsx";
import HamburgerButton from "../atoms/HamburgerButton";
import Breadcrumb from "../atoms/Breadcrumb";
import TimeDisplay from "../atoms/TimeDisplay";
import UserMenu from "../molecules/UserMenu";
import { useUserMenu } from "@/hooks";
import { useAuthStore } from "../../stores/authStore";
import { useSidebarStore } from "../../stores/sidebarStore";

function Header() {
  const { userMenuOpen, handleSignOut, toggleUserMenu } = useUserMenu();
  const { getUserDisplayName } = useAuthStore();
  const { toggleSidebar } = useSidebarStore();

  const currentUserName = getUserDisplayName();

  return (
    <header className="bg-white border-b-2 border-orange-500 sticky top-0 z-50 shadow-sm">
      <div className="flex items-center justify-between px-6 h-16">
        {/* Left: hamburger + logo + title */}
        <div className="flex items-center gap-4">
          <HamburgerButton onClick={toggleSidebar} />
          <div className="h-7 w-px bg-gray-200" />
          <Logo />
          <PortalTitle />
        </div>

        {/* Center: breadcrumb */}
        <div className="hidden md:flex flex-1 justify-center px-8">
          <Breadcrumb />
        </div>

        {/* Right: time, user */}
        <div className="flex items-center gap-3">
          <TimeDisplay className="hidden sm:block" />
          <div className="h-7 w-px bg-gray-200 hidden sm:block" />
          <UserMenu
            userName={currentUserName}
            isOpen={userMenuOpen}
            onToggle={toggleUserMenu}
            onSignOut={handleSignOut}
          />
        </div>
      </div>
    </header>
  );
}

export default Header;
